var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmentoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "260px",
    height: "48px",
    viewBox: "0 0 260 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 43 0 43 38 0 38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 36 0 36 38 0 38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 23 0 23 47 0 47"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrapped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page02-Copy-9",
    transform: "translate(-830.000000, -952.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(830.000000, 952.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(217.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.187123,38 C8.32930942,38 0,29.2982589 0,19 C0,7.99057953 7.64890946,0 18.187123,0 C26.9045479,0 30.4215449,4.12154092 32.7470434,6.84952477 C34.4320714,8.82479603 35.0629587,9.56472369 37.4379699,9.56472369 L43.0009583,9.56472369 L43.0009583,18.7203297 L37.4379699,18.7203297 C30.8432012,18.7203297 27.9203563,15.2939692 25.788117,12.7945159 C23.8523311,10.5251914 22.6847904,9.15560602 18.187123,9.15560602 C11.9437346,9.15560602 9.15026149,14.1001766 9.15026149,19 C9.15026149,24.2434183 13.3732134,28.844394 18.187123,28.844394 C22.5554185,28.844394 27.2239845,26.7604508 27.2239845,20.9113466 L36.374246,20.9113466 C36.374246,30.9730844 28.8962351,38 18.187123,38",
    id: "Fill-1",
    fill: "#D60A52",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2760035,14.9239771 C26.1270264,11.3569608 23.7531082,7.86299996 18.111409,7.86299996 C12.9895104,7.86299996 10.1686608,11.6475948 9.94681444,14.9239771 L26.2760035,14.9239771 Z M35.4801994,26.6446274 C33.6244625,32.8321143 27.8354055,38 18.853056,38 C8.83272459,38 -0.00064772666,30.9390229 -0.00064772666,18.854683 C-0.00064772666,7.42625486 8.60925889,0 17.9624319,0 C29.2458303,0 36,7.0625653 36,18.564049 C36,19.9457517 35.8510229,21.4036862 35.8510229,21.5497973 L9.72334875,21.5497973 C9.94681444,26.2809379 14.0291117,29.7018431 18.9275446,29.7018431 C23.5296425,29.7018431 26.0541571,27.4450621 27.2411162,24.2417353 L35.4801994,26.6446274 Z",
    id: "Fill-4",
    fill: "#D60A52",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,47 L44,11.0241442 L53.3003428,11.0241442 L53.3003428,15.4110546 C55.2783233,11.9015263 59.8925459,10 63.8469091,10 C68.753515,10 72.7078782,12.1200742 74.540466,15.9965077 C77.3955961,11.6095973 81.2045666,10 85.964182,10 C92.6282826,10 99,14.0216004 99,23.6728033 L99,47 L89.5526667,47 L89.5526667,25.6477106 C89.5526667,21.7728723 87.6481815,18.8487971 83.1809493,18.8487971 C79.0076981,18.8487971 76.5168487,22.0648012 76.5168487,25.9412348 L76.5168487,47 L66.8490297,47 L66.8490297,25.6477106 C66.8490297,21.7728723 64.872647,18.8487971 60.4789101,18.8487971 C56.2305659,18.8487971 53.7413142,21.9930154 53.7413142,25.9412348 L53.7413142,47 L44,47 Z",
    id: "Fill-7",
    fill: "#D60A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.276178,24.9239771 C132.127204,21.3569608 129.753329,17.863 124.111731,17.863 C118.989924,17.863 116.169126,21.6475948 115.947283,24.9239771 L132.276178,24.9239771 Z M141.480209,36.6446274 C139.624505,42.8321143 133.835552,48 124.853365,48 C114.833213,48 106,40.9390229 106,28.854683 C106,17.4262549 114.611371,10 123.962756,10 C135.245952,10 142,17.0625653 142,28.564049 C142,29.9457517 141.851026,31.4036862 141.851026,31.5497973 L115.723822,31.5497973 C115.947283,36.2809379 120.029507,39.7018431 124.927852,39.7018431 C129.529867,39.7018431 132.054336,37.4450621 133.241274,34.2417353 L141.480209,36.6446274 Z",
    id: "Fill-9",
    fill: "#D60A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.776056,47 L149,47 L149,10.9526525 L158.481026,10.9526525 L158.481026,15.4218075 C160.68573,11.6847244 165.022982,10 168.917691,10 C177.885623,10 182,16.3728616 182,24.2865906 L182,47 L172.225548,47 L172.225548,25.971315 C172.225548,21.9433212 170.240513,18.7928547 165.53768,18.7928547 C161.274185,18.7928547 158.776056,22.0887766 158.776056,26.2638241 L158.776056,47 Z",
    id: "Fill-11",
    fill: "#D60A52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(188.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8842378,10.6957351 L23,10.6957351 L23,19.2809565 L15.8842378,19.2809565 L15.8842378,34.2673977 C15.8842378,37.3957895 17.3221298,38.4147786 20.0536542,38.4147786 C21.203027,38.4147786 22.4966594,38.2687553 23,38.1243191 L23,46.1270342 C22.1375784,46.4905054 20.4127352,47 17.609081,47 C10.7097082,47 6.39760022,42.8526191 6.39760022,35.9403175 L6.39760022,19.2809565 L0,19.2809565 L0,10.6957351 L1.796973,10.6957351 C5.53361058,10.6957351 7.26002182,8.22127402 7.26002182,5.02145773 L7.26002182,-0.000476163138 L15.8842378,-0.000476163138 L15.8842378,10.6957351 Z",
    id: "Fill-13",
    fill: "#D60A52",
    mask: "url(#mask-6)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmentoLogo);
export default __webpack_public_path__ + "static/media/ementoLogo.d080165219270ca2bb42ad9c1025d315.svg";
export { ForwardRef as ReactComponent };